import { MapGeoJSONFeature } from "maplibre-gl";
import { Feature } from "../api-clients/iwannacamp-api";

interface WeatherAverages<T> {
  tmin?: T;
  tmean?: T;
  tmax?: T;
  precip?: T;
}

export const getMonthlyWeatherFromCampground = (
  campground: MapGeoJSONFeature | Feature
): WeatherAverages<number[]> => {
  try {
    if (!campground.properties) {
      return {
        tmin: undefined,
        tmean: undefined,
        tmax: undefined,
        precip: undefined,
      };
    }

    const tmin: number[] =
      typeof campground.properties[`tmin`] === "string"
        ? JSON.parse(campground.properties[`tmin`] ?? "[]")
        : campground.properties[`tmin`];
    const tmean: number[] =
      typeof campground.properties[`tmean`] === "string"
        ? JSON.parse(campground.properties[`tmean`] ?? "[]")
        : campground.properties[`tmean`];
    const tmax: number[] =
      typeof campground.properties[`tmax`] === "string"
        ? JSON.parse(campground.properties[`tmax`] ?? "[]")
        : campground.properties[`tmax`];
    const precip: number[] =
      typeof campground.properties[`precip`] === "string"
        ? JSON.parse(campground.properties[`precip`] ?? "[]")
        : campground.properties[`precip`];
    return { tmin, tmean, tmax, precip };
  } catch {
    return {
      tmin: undefined,
      tmean: undefined,
      tmax: undefined,
      precip: undefined,
    };
  }
};

export const getCurrentWeatherFromCampground = (
  campground: MapGeoJSONFeature | Feature
): WeatherAverages<number> => {
  const currentMonth = new Date().getMonth();
  const { tmin, tmean, tmax, precip } =
    getMonthlyWeatherFromCampground(campground);
  return {
    tmin: tmin?.[currentMonth],
    tmean: tmean?.[currentMonth],
    tmax: tmax?.[currentMonth],
    precip: precip?.[currentMonth],
  };
};

export const celsiusToFahrenheit = (celsius: number) => {
  return celsius * (9 / 5) + 32;
};

export const mmToInches = (mm: number) => {
  return mm / 25.4;
};
